import React, { useEffect, useState } from "react";
import { Breadcrumbs, Link, Box, useTheme } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
// import { useUser } from "../hooks/Authorize";
import axios from "axios";

const FolderBreadcrumbs = ({ setClikkleItems }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  // const platformUser = JSON.parse(localStorage.getItem("user"));
  const params = new URLSearchParams(location.search);
  const parentId = params.get("parentId");
  const [folderPath, setFolderPath] = useState([]);
  const isViewer = location.pathname.includes("/view");

  // Get the root name based on current route
  const getRootName = () => {
    if (isViewer) return null; // For viewer mode, we'll use the actual folder name

    const path = location.pathname;
    if (path.includes("/favorite")) return "Favorites";
    if (path.includes("/recent")) return "Recent";
    if (path.includes("/trash")) return "Trash";
    if (path.includes("/shared-by-me")) return "Shared by me";
    if (path.includes("/shared-with-me")) return "Shared with me";
    return "My Files"; // Default for /my-files
  };

  useEffect(() => {
    const fetchFolderPath = async () => {
      try {
        const rootName = getRootName();

        if (!parentId) {
          setFolderPath(rootName ? [{ name: rootName, id: null }] : []);
          return;
        }

        const response = await axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${parentId}/path`, {
          params: { isViewer }
        });

        // For viewer mode, don't prepend "My Files" - just use the actual path
        const pathItems = isViewer
          ? response.data
          : [{ name: rootName, id: null }, ...response.data];

        setFolderPath(pathItems);
      } catch (error) {
        console.error("Error fetching folder path:", error);
      }
    };
    fetchFolderPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentId, location.pathname]);

  const handleBreadcrumbClick = async (folderId) => {
    const queryParams = new URLSearchParams(location.search);
    if (folderId) {
      queryParams.set("parentId", folderId);
    } else {
      queryParams.delete("parentId");
    }
    navigate(`${location.pathname}?${queryParams.toString()}`);

    // try {
    //   const response = await axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs`, {
    //     params: {
    //       ...(isViewer ? {} : { ownerId: platformUser._id }),
    //       parentId: folderId || '',
    //       isViewer,
    //       ...(location.pathname.includes("/favorite") && { isStarred: true }),
    //       ...(location.pathname.includes("/trash") && { isTrashed: true }),
    //       ...(location.pathname.includes("/shared-by-me") && { sharedByMe: true }),
    //       ...(location.pathname.includes("/shared-with-me") && { sharedWithMe: true }),
    //       ...(location.pathname.includes("/recent") && { recent: true })
    //     }
    //   });
    //   setClikkleItems(response.data);
    // } catch (error) {
    //   console.error("Error fetching folder data:", error);
    // }
  };

  if (folderPath.length <= 1) return null;

  return (
    <Box sx={{
      padding: "8px 10px",
      display: "flex",
      alignItems: "center",
    }}>
      <Breadcrumbs
        separator={
          <Box component="span" sx={{
            color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#5f6368',
            fontSize: "22px",
            margin: "0px",
            lineHeight: 1
          }}>
            ›
          </Box>
        }
        sx={{
          '& .MuiBreadcrumbs-ol': {
            gap: '4px'
          }
        }}
      >
        {folderPath.map((folder, index) => (
          <Box
            key={folder.id || "root"}
            sx={{
              padding: "4px 12px",
              borderRadius: "100px",
              transition: "all 0.2s ease",
              marginRight: "0px",
              "&:hover": {
                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(95, 99, 104, 0.1)'
              }
            }}
          >
            <Link
              color={index === folderPath.length - 1 ? "textPrimary" : "inherit"}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleBreadcrumbClick(folder.id);
              }}
              sx={{
                textDecoration: "none",
                color: index === folderPath.length - 1
                  ? theme.palette.mode === 'dark'
                    ? '#ffffff'
                    : '#202124'
                  : theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.8)'
                    : '#5f6368',
                fontSize: "15px",
                fontWeight: index === folderPath.length - 1 ? "600" : "500",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "none",
                  color: theme.palette.mode === 'dark' ? '#ffffff' : '#202124'
                }
              }}
            >
              {folder.name}
            </Link>
          </Box>
        ))}
      </Breadcrumbs>
    </Box>
  );
};

export default FolderBreadcrumbs;